/* jk-buy-ways.js — блок «Способы покупки» на карточке ЖК (секция #jkMortgage).
   Перенос принятого владельцем черновика tools/.hero-draft/buy-ways.js в боевой код.
   Эталон вида — hero-draft-backup/FINAL-8901_2026-08-18_0008/.

   ⛔ РАЗМЕТКУ ЗДЕСЬ НЕ СОБИРАЕМ. Весь блок печатает сервер
      (app/templates/components/jk-buy-ways.php). Скрипт только оживляет уже
      напечатанное: переключает вкладки, считает платёж и открывает окно заявки.
      Причина не в аккуратности: показанная ставка обязывает раскрыть ПСК
      (ст. 28 ч. 3 38-ФЗ), а собранное скриптом раскрытие исчезает вместе с ним.

   ⛔ ДАННЫЕ БЕРЁМ ИЗ СВОИХ data-*, А НЕ ИЗ ЧУЖОЙ РАЗМЕТКИ. Черновик читал имя ЖК
      из <h1>, а комнатность — из чипов фильтра. Чипы рисуются после ответа API,
      и на момент запуска их ещё нет: шаг воронки молча выпадал.

   ⛔ ФОРМУЛУ АННУИТЕТА НЕ ДУБЛИРУЕМ. Она одна на сайт — window.calcMonthly
      (js/utils.js). Вторая копия разъехалась бы с первой при первой же правке.

   ⛔ ЗАЯВКА ОТСЮДА УХОДИТ ПО-НАСТОЯЩЕМУ, тем же путём, что и с окна карточки:
      POST /send.php → SendHandler. Свой endpoint не заводим. */
(() => {
  'use strict';

  const RUB = ' ';                         // неразрывный пробел в разрядах

  /* ── Чистая арифметика ──────────────────────────────────────────────────
     Считается и проверяется без DOM: тест tests/JS/jk-buy-ways.test.js дёргает
     эти функции напрямую. Поэтому объявлены ДО охранника — иначе на странице
     без блока их бы не существовало вовсе. */
  const api = {
    /** Число рублями, как их читают люди: 1 234 567. */
    money(n) {
      return Math.round(n).toLocaleString('ru-RU').replace(/\s/g, RUB);
    },

    /**
     * Ежемесячный платёж по телу кредита.
     * @param {number} body тело кредита, ₽
     * @param {number} ratePct годовая ставка, %
     * @param {number} years срок, лет
     * @returns {number|null} null — если общесайтовой формулы нет на странице
     */
    monthly(body, ratePct, years) {
      if (typeof window.calcMonthly !== 'function') return null;
      if (!(body > 0) || !(years > 0) || ratePct == null) return null;
      // downPct=0: взнос уже вычтен из тела кредита выше по потоку — иначе
      // материнский капитал вычелся бы дважды.
      return window.calcMonthly(body, 0, ratePct, years);
    },

    /**
     * Три доли кольца: взнос / тело / переплата.
     * @returns {{down:number,body:number,over:number,total:number}}
     */
    parts(price, downTotal, monthlyPay, years) {
      const down = Math.max(0, Math.min(price, downTotal));
      const body = Math.max(0, price - down);
      const over = monthlyPay == null ? 0 : Math.max(0, monthlyPay * years * 12 - body);
      return { down: down, body: body, over: over, total: down + body + over };
    },

    /** Правильное окончание года: 1 год / 3 года / 30 лет. */
    yearsWord(y) {
      return y + (y === 1 ? ' год' : y < 5 ? ' года' : ' лет');
    },
  };
  window.BroniBuyWays = api;

  const host = document.getElementById('jkBuyWays');
  if (!host) return;

  const $ = sel => host.querySelector(sel);
  const $$ = sel => [].slice.call(host.querySelectorAll(sel));
  const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Программы: читаем СВОИ атрибуты, напечатанные сервером ────────────
     ⛔ Отсутствие data-rate означает «ставки нет», а не «ставка ноль». Поэтому
        проверяем наличие атрибута, а не результат parseFloat. */
  const progs = $$('.bw-prog').map(btn => ({
    el: btn,
    name: btn.getAttribute('data-name') || '',
    rate: btn.hasAttribute('data-rate') ? parseFloat(btn.getAttribute('data-rate')) : null,
    down: btn.hasAttribute('data-down') ? parseInt(btn.getAttribute('data-down'), 10) : null,
    why: btn.getAttribute('data-why') || '',
  }));
  if (!progs.length) return;

  let cur = 0;

  // ── Вкладки способов ────────────────────────────────────────────────────
  const tabs = $$('.bw-tab');
  const pill = $('.bw-tabs__pill');
  const panes = $$('.bw-pane');

  function movePill(btn) {
    if (!pill || !btn) return;
    pill.style.width = btn.offsetWidth + 'px';
    pill.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
  }

  tabs.forEach(btn => btn.addEventListener('click', () => {
    tabs.forEach(x => {
      const on = x === btn;
      x.classList.toggle('is-active', on);
      x.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panes.forEach(p => p.classList.toggle('is-on', p.getAttribute('data-p') === btn.getAttribute('data-k')));
    movePill(btn);
  }));
  requestAnimationFrame(() => movePill(tabs[0]));
  window.addEventListener('resize', () => {
    movePill(tabs.filter(t => t.classList.contains('is-active'))[0]);
  }, { passive: true });

  /* ── Плавный набор числа ────────────────────────────────────────────────
     ⛔ ЗДЕСЬ БЫЛА ЛЕНТА ИЗ ДЕСЯТИ ЦИФР С ПЕРЕКАТОМ. Идея красивая, исполнение —
        нет: в каждой ячейке было видно ДВЕ цифры разом, глифы обрезаны сверху и
        снизу. Набор значения обрезаться не может в принципе.
     ⛔ При prefers-reduced-motion анимацию гасим: скачущие деньги — плохая идея
        для того, кто просил покоя. */
  const odo = $('#bwOdo');
  let shown = 0;
  let raf = 0;

  function renderOdo(target) {
    odo.classList.remove('is-ind');
    if (calm) { odo.textContent = api.money(target); shown = target; return; }
    cancelAnimationFrame(raf);
    const from = shown;
    const delta = target - from;
    const t0 = performance.now();
    const step = now => {
      const k = Math.min(1, (now - t0) / 480);
      const eased = 1 - Math.pow(1 - k, 3);       // мягкое торможение
      odo.textContent = api.money(from + delta * eased);
      if (k < 1) raf = requestAnimationFrame(step); else shown = target;
    };
    raf = requestAnimationFrame(step);
  }

  // ── Расчёт ──────────────────────────────────────────────────────────────
  const price = $('#bwPrice');
  const down = $('#bwDown');
  const term = $('#bwTerm');
  const downRub = $('#bwDownRub');
  const downPct = $('#bwDownPct');
  /* ⛔ Порог взноса — из справочника, его печатает сервер в `min` ползунка.
     Читаем ОДИН раз при запуске: дальше `min` временно уходит в ноль у
     программы «Без первого взноса», и вернуть его будет уже неоткуда. */
  const DOWN_FLOOR = Math.max(0, parseInt(down.getAttribute('min'), 10) || 0);
  const matEl = $('#bwMat');
  const subEl = $('#bwSub');
  const curEl = $('#bwCur');
  const perEl = $('#bwPer');
  const arcDown = $('#bwArcDown');
  const arcBody = $('#bwArcBody');
  const arcOver = $('#bwArcOver');
  const RING = 2 * Math.PI * 82;
  const PER_DEFAULT = perEl.textContent;

  const num = el => +String(el.value).replace(/[^\d]/g, '') || 0;

  function fillRange(el) {
    const pct = ((el.value - el.min) / (el.max - el.min)) * 100;
    el.style.background = 'linear-gradient(90deg, var(--gold) 0%, var(--gold) ' + pct +
      '%, rgba(255,255,255,.09) ' + pct + '%, rgba(255,255,255,.09) 100%)';
  }

  function setArcs(p) {
    const seg = v => (p.total > 0 ? (v / p.total) * RING : 0);
    arcDown.setAttribute('stroke-dasharray', seg(p.down) + ' ' + RING);
    arcDown.setAttribute('stroke-dashoffset', '0');
    arcBody.setAttribute('stroke-dasharray', seg(p.body) + ' ' + RING);
    arcBody.setAttribute('stroke-dashoffset', String(-seg(p.down)));
    arcOver.setAttribute('stroke-dasharray', seg(p.over) + ' ' + RING);
    arcOver.setAttribute('stroke-dashoffset', String(-(seg(p.down) + seg(p.body))));
  }

  function clearArcs() {
    [arcDown, arcBody, arcOver].forEach(a => a.setAttribute('stroke-dasharray', '0 ' + RING));
  }

  /** Короткая переплата в кольцо: от миллиона — «12,3 млн ₽». */
  function overShort(over) {
    if (over < 1000000) return api.money(over) + ' ₽';
    // ⛔ От сотни миллионов десятые не нужны: «282,0 млн ₽» не влезало в кольцо
    //    и рубль переносился на вторую строку.
    const v = over >= 100000000 ? Math.round(over / 1000000) : (over / 1000000).toFixed(1).replace('.', ',');
    return v + ' млн ₽';
  }

  function readInputs() {
    const p = +price.value;
    const dp = +down.value;
    const mat = matEl ? num(matEl) : 0;
    return { p: p, dp: dp, yrs: +term.value, mat: mat, downTotal: Math.min(p, p * dp / 100 + mat) };
  }

  function syncFields(v) {
    fillRange(price); fillRange(down); fillRange(term);
    $('#bwPriceV').textContent = api.money(v.p) + ' ₽';
    $('#bwTermV').textContent = api.yearsWord(v.yrs);
    if (document.activeElement !== downRub) downRub.value = api.money(v.p * v.dp / 100);
    if (document.activeElement !== downPct) downPct.value = v.dp;
    $$('.bw-mark').forEach(m => m.classList.toggle('is-on', +m.getAttribute('data-m') === v.dp));
  }

  /* ⛔ БЕЗ СТАВКИ — БЕЗ ЧИСЛА. Ни «примерно», ни «от»: показанная ставка обязывает
     раскрыть ПСК, а выдуманная — это ещё и обман. Вместо платежа — причина, по
     которой считаем индивидуально, и переход к заявке. */
  function showIndividual(v, prog, subsidised) {
    cancelAnimationFrame(raf);
    shown = 0;
    odo.textContent = 'Считаем индивидуально';
    odo.classList.add('is-ind');
    curEl.classList.add('is-hidden');
    perEl.textContent = subsidised
      ? 'Ставку субсидирует застройщик — у каждого дома она своя. Уточним по этому ЖК и пришлём расчёт.'
      : (prog.why || 'Условия по этой программе считаем индивидуально.');
    clearArcs();
    $('#bwRingBig').textContent = '—';
    $('#bwLegDown').textContent = api.money(v.downTotal) + ' ₽';
    $('#bwLegBody').textContent = api.money(v.p - v.downTotal) + ' ₽';
    $('#bwLegOver').textContent = 'зависит от условий';
  }

  function calc() {
    const v = readInputs();
    const prog = progs[cur];
    syncFields(v);

    const subsidised = !!(subEl && subEl.checked);
    const pay = prog.rate == null || subsidised ? null : api.monthly(v.p - v.downTotal, prog.rate, v.yrs);
    if (pay == null) {
      showIndividual(v, prog, subsidised);
      return;
    }

    curEl.classList.remove('is-hidden');
    perEl.textContent = PER_DEFAULT;
    const parts = api.parts(v.p, v.downTotal, pay, v.yrs);
    renderOdo(pay);
    setArcs(parts);
    $('#bwRingBig').textContent = overShort(parts.over);
    $('#bwLegDown').textContent = api.money(parts.down) + ' ₽';
    $('#bwLegBody').textContent = api.money(parts.body) + ' ₽';
    $('#bwLegOver').textContent = api.money(parts.over) + ' ₽';
  }

  [price, down, term].forEach(el => el.addEventListener('input', calc));
  $$('.bw-mark').forEach(m => m.addEventListener('click', () => {
    down.value = m.getAttribute('data-m');
    calc();
  }));

  // Рубли и проценты ведут друг друга. Правим ползунок, а не саму цифру, — тогда
  // источник истины один и расхождения между полями невозможны.
  downRub.addEventListener('input', () => {
    const p = +price.value;
    down.value = Math.min(+down.max, Math.max(+down.min, Math.round(num(downRub) / p * 100)));
    calc();
  });
  downPct.addEventListener('input', () => {
    down.value = Math.min(+down.max, Math.max(+down.min, num(downPct)));
    calc();
  });
  [downRub, downPct].forEach(el => el.addEventListener('blur', calc));
  if (matEl) matEl.addEventListener('input', calc);
  if (subEl) subEl.addEventListener('change', calc);

  $$('.bw-mode__b').forEach(btn => btn.addEventListener('click', () => {
    $$('.bw-mode__b').forEach(x => x.classList.toggle('is-active', x === btn));
    $('#bwMore').hidden = btn.getAttribute('data-mode') !== 'full';
  }));

  $$('.bw-prog').forEach((btn, i) => btn.addEventListener('click', e => {
    $$('.bw-prog').forEach(x => {
      x.classList.remove('is-active');
      x.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');

    const box = btn.getBoundingClientRect();
    btn.style.setProperty('--x', (e.clientX - box.left) + 'px');
    btn.style.setProperty('--y', (e.clientY - box.top) + 'px');
    btn.classList.remove('is-ripple');
    void btn.offsetWidth;                          // перезапуск анимации волны
    btn.classList.add('is-ripple');

    cur = i;
    /* ⛔ У «Без первого взноса» ползунок обязан дойти до нуля. Обычно он
       ограничен снизу минимальным взносом банков-партнёров, но для этой
       программы ноль и есть суть. Границу отпускаем только пока выбрана она,
       и возвращаем обратно при уходе.
       ⛔ ВОЗВРАЩАЕМ СЕРВЕРНЫЙ ПОРОГ, А НЕ ЛИТЕРАЛ. Здесь стояло `down.min = 10`,
       и после ухода с «Без первого взноса» ползунок вставал на 10 % — при том
       что минимум партнёров 15 % (справочник `mortgage_rates`), кнопки уже
       показывали 15/20/30/50, а подпись говорила «минимальный взнос — 15 %».
       Человек видел платёж по условиям, которых нет ни у одного банка.
       Порог печатает сервер в атрибут `min`; запомнили его при запуске. */
    if (progs[i].down === 0) {
      down.min = 0;
      down.value = 0;
    } else if (+down.min === 0) {
      down.min = DOWN_FLOOR;
      if (+down.value < DOWN_FLOOR) down.value = DOWN_FLOOR;
    }
    calc();
  }));

  /* ══════════════════════════════════════════════════════════════════════
     ОКНО ЗАЯВКИ ПО ИПОТЕКЕ

     ⛔ СТРОИМ ТЕМИ ЖЕ КЛАССАМИ `.jkcb-*`, ЧТО И КАРТОЧНОЕ ОКНО. Всё его
        оформление уже лежит в css/jk.css — вторая правда о том, как выглядит
        окно, разъехалась бы с первой при первой же правке.
     ⛔ `.jkcb-*` в jk.css заперты в медиа-запросе ОТ 901 px, поэтому мобильную
        часть даёт css/jk-buy-ways.css (правила под `.bw-mortwin`). Окно карточки
        при этом не трогаем — селекторы вложены в наш собственный класс.
     ⛔ ЗАЯВКА УХОДИТ ПО-НАСТОЯЩЕМУ. Показать «Заявка принята», не отправив
        заявку, — это ложь. Путь ровно тот же, что у окна карточки:
        POST /send.php (checkPublicForm: honeypot + Origin, checkFormRate,
        SmartCaptcha; PII маскируется на сервере через maskPhone). */
  let win = null;
  let winPhone = null;
  let winErr = null;
  let winSend = null;
  let winAgree = null;
  let cameFrom = null;

  /* ══════════════════════════════════════════════════════════════════════
     ГАЛЕРЕЯ РЕНДЕРОВ В ОКНЕ ЗАЯВКИ (18.08.2026)

     Просьба владельца: «в заявке на ипотеку должны быть рендеры ЖК и они должны
     листаться». В черновике окна кадр был один (узел `.jkcb-photo`), а при
     переносе в боевой код пропал и он — `buildLeft()` фото не рисовал вовсе.

     ⛔ АДРЕСА ПРИХОДЯТ ИЗ data-shots, А НЕ ИЗ ЧУЖОЙ РАЗМЕТКИ СТРАНИЦЫ. Черновик
        брал кадр из `.jk-about__hero img` — то есть из соседнего блока, который
        рисуется после ответа API. На момент открытия окна его может не быть, и
        фото молча исчезало бы через раз.
     ⛔ SRC СТАВИМ ПРИ ОТКРЫТИИ, А НЕ ЗАРАНЕЕ. Окно живёт в скрытом слое: браузер
        не грузит картинку, у предка которой `display:none`, — ленивая загрузка
        там не срабатывает НИКОГДА.
     ⛔ ГРУЗИМ ТЕКУЩИЙ КАДР И СОСЕДНИЙ, а не всю пачку. Восемь кадров разом — это
        лишний трафик ради картинки, которую человек, возможно, не пролистает. */
  function parseShots() {
    try {
      const raw = host.getAttribute('data-shots');
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(u => typeof u === 'string' && u) : [];
    } catch (e) {
      return [];
    }
  }

  function buildShots(box) {
    const shots = parseShots();
    if (!shots.length) return;                       // нет кадров — нет и пустой рамки

    let at = 0;
    const wrap = el('div', 'jkcb-photo bw-shots');
    const img = el('img', 'bw-shots__img');
    img.alt = '';
    img.decoding = 'async';
    wrap.appendChild(img);

    const dots = el('div', 'bw-shots__dots');
    const dotNodes = shots.map((_, i) => {
      const d = el('span', 'bw-shots__dot' + (i === 0 ? ' is-on' : ''));
      dots.appendChild(d);
      return d;
    });

    // Соседний кадр подгружаем заранее — листание тогда мгновенное.
    const warm = (i) => {
      if (i < 0 || i >= shots.length) return;
      const pre = new Image();
      pre.src = shots[i];
    };

    const show = (i) => {
      at = (i + shots.length) % shots.length;
      img.src = shots[at];
      dotNodes.forEach((d, k) => d.classList.toggle('is-on', k === at));
      warm(at + 1);
    };

    if (shots.length > 1) {
      const prev = el('button', 'bw-shots__nav bw-shots__nav--prev', '‹');
      const next = el('button', 'bw-shots__nav bw-shots__nav--next', '›');
      prev.type = 'button';
      next.type = 'button';
      prev.setAttribute('aria-label', 'Предыдущий кадр');
      next.setAttribute('aria-label', 'Следующий кадр');
      prev.addEventListener('click', () => show(at - 1));
      next.addEventListener('click', () => show(at + 1));
      wrap.appendChild(prev);
      wrap.appendChild(next);
      wrap.appendChild(dots);
    }

    show(0);
    box.appendChild(wrap);
  }

  function el(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;              // ⛔ только textContent
    return node;
  }

  function digits(v) {
    let d = String(v).replace(/\D/g, '');
    if (d[0] === '8' || d[0] === '7') d = d.slice(1);        // код страны, не первая цифра
    return d.slice(0, 10);
  }

  function mask() {
    const d = digits(winPhone.value);
    if (!d.length) { winPhone.value = ''; return; }
    let out = '+7 (' + d.slice(0, 3);
    if (d.length >= 4) out += ') ' + d.slice(3, 6);
    if (d.length >= 7) out += '-' + d.slice(6, 8);
    if (d.length >= 9) out += '-' + d.slice(8, 10);
    winPhone.value = out;
    if (d.length === 10) { winPhone.classList.remove('is-bad'); winErr.classList.remove('is-on'); }
  }

  /** Строки расчёта — ровно то, что человек выставил сам. */
  function summaryRows() {
    const v = readInputs();
    const prog = progs[cur];
    return [
      ['Программа', prog.name + (prog.rate == null ? '' : ' · ' + String(prog.rate).replace('.', ',') + '%')],
      ['Стоимость', api.money(v.p) + ' ₽'],
      ['Первый взнос', v.dp + '% · ' + api.money(v.downTotal) + ' ₽'],
      ['Срок', api.yearsWord(v.yrs)],
      ['Сумма кредита', api.money(v.p - v.downTotal) + ' ₽'],
    ];
  }

  function buildLeft(box) {
    const prog = progs[cur];
    box.textContent = '';
    box.appendChild(el('div', 'jkcb-name', 'Ипотека в ' + (host.getAttribute('data-jk-name') || 'этом ЖК')));
    box.appendChild(el('div', 'jkcb-deadline', prog.rate == null ? 'Расчёт' : 'Платёж от'));
    box.appendChild(prog.rate == null
      ? el('div', 'jkcb-price bw-mortwin__ind', 'Считаем индивидуально')
      : el('div', 'jkcb-price', odo.textContent.trim() + ' ₽/мес'));

    // Рендеры ЖК — между ценой и расчётом, как в принятом черновике.
    buildShots(box);

    const rows = el('div', 'bw-mortwin__rows');
    summaryRows().forEach(r => {
      const row = el('div', 'bw-mortwin__row');
      row.appendChild(el('span', '', r[0]));
      row.appendChild(el('b', '', r[1]));
      rows.appendChild(row);
    });
    box.appendChild(rows);
  }

  function buildExpert(box) {
    const top = el('div', 'jkcb-expert');
    const ava = el('div', 'jkcb-ava', 'Б');
    // Щит БРОНИДОМ из шапки — тот же источник, что у карточного окна, и он уже в
    // кэше браузера. Нет логотипа — остаётся честная буква.
    const logo = document.querySelector('.logo-mark, .preloader-brand');
    const logoSrc = logo ? logo.getAttribute('src') : '';
    if (logoSrc) {
      const pic = document.createElement('img');
      pic.setAttribute('src', logoSrc);
      pic.setAttribute('alt', '');
      pic.setAttribute('decoding', 'async');
      // ⛔ Размер задаём здесь: в CSS размеряется `canvas`, а не `img`, и
      //    натуральные 96 px вылезали бы из кружка в 56 px.
      pic.width = 40;
      pic.height = 40;
      ava.textContent = '';
      ava.classList.add('jkcb-ava--logo');
      ava.appendChild(pic);
    }
    top.appendChild(ava);
    const who = el('div', 'jkcb-who');
    who.appendChild(el('b', '', 'Ипотечный менеджер БРОНИДОМ'));
    who.appendChild(el('span', '', 'Подберёт программу и соберёт документы'));
    top.appendChild(who);
    box.appendChild(top);
  }

  function buildConsent() {
    const label = el('label', 'jkcb-agree');
    winAgree = document.createElement('input');
    winAgree.type = 'checkbox';
    winAgree.required = true;
    // ⛔ Имя обязательно: под `consent_main` заявку ждёт SendHandler (ConsentRequest),
    //    по нему же общий гейт сайта находит согласие.
    winAgree.name = 'consent_main';
    winAgree.id = 'bwWinConsent';
    label.htmlFor = 'bwWinConsent';
    label.appendChild(winAgree);
    const box = el('span', 'jkcb-box', '✓');
    box.setAttribute('aria-hidden', 'true');
    label.appendChild(box);
    const text = el('span', '', 'Согласен на обработку моих персональных данных (имя, телефон). ');
    const link = el('a', '', 'Согласие на обработку ПДн');
    link.href = '/soglasie.php';
    link.target = '_blank';
    link.rel = 'noopener';
    text.appendChild(link);
    label.appendChild(text);
    winAgree.addEventListener('change', () => {
      if (winAgree.checked && typeof window.hideConsentHint === 'function') window.hideConsentHint(winAgree);
    });
    return label;
  }

  function buildRight(box) {
    box.textContent = '';
    buildExpert(box);
    box.appendChild(el('div', 'jkcb-phrase',
      'Отправим ваш расчёт в банки-партнёры и вернёмся с лучшей ставкой. ' +
      'Без визита в отделение и без навязчивых звонков потом.'));

    /* Три строки закрывают пустую дыру в правой колонке: в штатном окне между
       вступлением и обещанием зияет треть высоты. Заполняем не «водой», а тем,
       что человек хочет знать перед тем, как оставить номер. */
    const list = el('ul', 'bw-mortwin__list');
    ['Отправим расчёт сразу в несколько банков-партнёров',
      'Ставку и условия назовём до сделки, а не после',
      'Документы соберём вместе — ходить по отделениям не нужно']
      .forEach(t => list.appendChild(el('li', '', t)));
    box.appendChild(list);

    const form = el('form', 'jkcb-form');
    form.setAttribute('novalidate', 'novalidate');
    // ⛔ У формы СВОЙ гейт согласия, поэтому помечаем её так же, как podbor.js и
    //    flat.js: общий гейт shared.js её пропускает и два обработчика не спорят.
    form.setAttribute('data-consent-gate-skip', '');
    form.appendChild(el('div', 'jkcb-promise', 'Ответим в течение 15 минут и назовём реальную ставку под ваш случай'));

    winPhone = document.createElement('input');
    winPhone.type = 'tel';
    winPhone.className = 'jkcb-input ym-hide-content';      // номер не уходит в Метрику
    winPhone.setAttribute('placeholder', '+7 (___) ___-__-__');
    winPhone.setAttribute('autocomplete', 'tel');
    winPhone.setAttribute('aria-label', 'Номер телефона');
    winPhone.setAttribute('data-ym-disable-keys', 'true');
    form.appendChild(winPhone);

    winErr = el('div', 'jkcb-err', 'Введите номер полностью — 10 цифр после +7');
    form.appendChild(winErr);

    winSend = el('button', 'jkcb-submit', 'Подобрать ставку');
    winSend.type = 'submit';
    // ⛔⛔ КНОПКУ НЕ ДИЗЕЙБЛИМ до галочки. Приём снят с сайта после инцидента
    //     16.07.2026: человек жал мёртвую кнопку, не получал ничего и уходил
    //     уверенный, что заявку отправил. Лид терялся молча.
    form.appendChild(winSend);
    form.appendChild(buildConsent());

    form.appendChild(el('div', 'bw-mortwin__note', 'Номер нужен только для звонка по этой заявке.'));

    winPhone.addEventListener('input', mask);
    form.addEventListener('submit', submitLead);
    box.appendChild(form);
  }

  function leadFail(text) {
    winSend.disabled = false;
    winSend.textContent = 'Подобрать ставку';
    winErr.textContent = text;
    winErr.classList.add('is-on');
  }

  /** Тело заявки. Скрытые поля берём у штатной формы подвала — там CSRF и honeypot. */
  function leadBody(phone) {
    const v = readInputs();
    const prog = progs[cur];
    const body = new URLSearchParams();
    const native = document.getElementById('callbackForm');
    if (native) {
      native.querySelectorAll('input[type=hidden]').forEach(h => {
        if (h.name) body.append(h.name, h.value);
      });
      if (native.querySelector('input[name=_hp]')) body.append('_hp', '');
    }
    body.append('name', 'Заявка «Способы покупки»');
    body.append('phone', '+7' + phone);
    body.append('consent_main', '1');
    // Метка «откуда пришла заявка»: без неё SendHandler ставит всем «Сайт».
    // Страница комнатности называет себя сама (window.BRONI_LEAD_PAGE, flats.php).
    body.append('_source', (typeof window.BRONI_LEAD_PAGE === 'string' && window.BRONI_LEAD_PAGE ? window.BRONI_LEAD_PAGE : 'Карточка ЖК') + ' — способы покупки');
    body.append('comment', [
      'Способы покупки, ' + (host.getAttribute('data-jk-name') || ''),
      'Программа: ' + prog.name + (prog.rate == null ? ' (ставка индивидуальная)' : ' · ' + prog.rate + '%'),
      'Стоимость: ' + api.money(v.p) + ' ₽',
      'Взнос: ' + v.dp + '% (' + api.money(v.downTotal) + ' ₽)',
      'Срок: ' + api.yearsWord(v.yrs),
      funnelSummaryText(),
    ].filter(Boolean).join('; '));
    return body;
  }

  function submitLead(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const d = digits(winPhone.value);
    if (d.length !== 10) {
      winPhone.classList.add('is-bad');
      winErr.classList.add('is-on');
      winPhone.focus();
      return;
    }
    /* ⛔ 152-ФЗ ст. 9 ч. 4: без ОТМЕЧЕННОГО согласия заявку не отправляем вовсе.
       Проверяем реальное состояние флажка, а не шлём единицу константой: строка
       уходит в pdn_consents — журнал, который показывают РКН. */
    if (!winAgree.checked) {
      if (typeof window.showConsentHint === 'function') window.showConsentHint(winAgree);
      else {
        winErr.textContent = 'Отметьте согласие на обработку персональных данных';
        winErr.classList.add('is-on');
      }
      return;
    }
    winSend.disabled = true;
    winSend.textContent = 'Отправляем…';

    fetch('/send.php', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: leadBody(d).toString(),
    })
      // ⛔ Проверка r.ok ОБЯЗАТЕЛЬНА. Без неё «Заявка принята» рисовалась бы на
      //    любом ответе, включая 403: человек уходит довольным, а заявки нет.
      .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r; })
      .then(() => leadDone(form))
      .catch(() => leadFail('Не получилось отправить. Попробуйте ещё раз или позвоните нам.'));
  }

  /* ⛔ ЦЕЛЬ МЕТРИКИ УХОДИТ ЗДЕСЬ — В ВЕТКЕ УСПЕШНОГО ОТВЕТА СЕРВЕРА, а не по клику
     по кнопке. Цель на клике считает намерения, а владелец по этой цифре считает
     деньги: восемь форм сайта уже молчали так, что заявок в Метрике не было вовсе
     (сторож — tests/JS/lead-form-ym-goal.test.js).
     ⛔ Цель берём СУЩЕСТВУЮЩУЮ — `form_mortgage`. Её уже шлют mortgage-page.js,
        index.js и cabinet.js, то есть она настроена в счётчике и попадает в тот же
        отчёт по ипотечным заявкам. Своё новое имя пришлось бы заводить руками в
        Метрике, а до этого оно не считалось бы нигде.
     Формы блока различаем параметрами: `source` — какой блок, `program` — какую
     программу человек выбрал, `way` — что он ответил в воронке (если отвечал). */
  function leadDone(form) {
    form.textContent = '';
    const ok = el('div', 'jkcb-done');
    ok.appendChild(el('b', '', 'Заявка принята'));
    ok.appendChild(el('span', '', 'Перезвоним в течение 15 минут в рабочее время. ' +
      'Номер никому не передаём и не используем для рассылок.'));
    form.appendChild(ok);
    if (typeof window.ymGoal !== 'function') return;
    window.ymGoal('form_mortgage', {
      source: 'jk_buyways',
      program: progs[cur].name,
      way: answers.way || '',
    });
  }

  function closeWin() {
    if (!win) return;
    win.remove();
    win = null;
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';
    document.removeEventListener('keydown', winKey, true);
    if (cameFrom && cameFrom.focus) cameFrom.focus();
  }

  function winKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeWin(); return; }
    // Кольцо фокуса: Tab не должен уводить человека на страницу под окном.
    if (e.key !== 'Tab' || !win) return;
    const can = win.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])');
    if (!can.length) return;
    const first = can[0];
    const last = can[can.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openWin() {
    closeWin();
    cameFrom = document.activeElement;

    win = el('div', 'jkcb-back bw-mortwin');
    const shell = el('div', 'jkcb-win');
    shell.setAttribute('role', 'dialog');
    shell.setAttribute('aria-modal', 'true');
    shell.setAttribute('aria-label', 'Заявка на ипотеку');

    const close = el('button', 'jkcb-close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Закрыть');
    close.addEventListener('click', closeWin);
    shell.appendChild(close);

    const left = el('div', 'jkcb-left');
    const right = el('div', 'jkcb-right');
    buildLeft(left);
    buildRight(right);
    shell.appendChild(left);
    shell.appendChild(right);
    win.appendChild(shell);
    win.addEventListener('click', e => { if (e.target === win) closeWin(); });
    document.body.appendChild(win);

    // Прокрутку под окном запираем и компенсируем полосу — иначе страница
    // дёргается вбок, как и в штатном окне.
    const bar = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    if (bar > 0) document.documentElement.style.paddingRight = bar + 'px';
    document.addEventListener('keydown', winKey, true);
    winPhone.focus();
  }

  $$('.bw-lead').forEach(btn => btn.addEventListener('click', openWin));

  /* ── Воронка заявки ─────────────────────────────────────────────────────
     ⛔ Каждый ответ двигает дальше САМ. Кнопка «далее» на каждом шаге — главная
        причина, по которой такие формы бросают.
     ⛔ Шаги напечатаны сервером; здесь только переключаем видимый. */
  const funSteps = $$('.bw-funnel__step');
  const funBack = $('#bwFunBack');
  const funDone = $('#bwFunDone');
  const funSum = $('#bwFunSum');
  const funBar = $('#bwFunBar');
  const answers = {};
  let stepIdx = 0;

  function funnelSummaryText() {
    const bits = funSteps
      .map(s => answers[s.getAttribute('data-step')])
      .filter(Boolean);
    return bits.length ? 'Ответы: ' + bits.join(', ') : '';
  }

  function drawFunnel() {
    const done = stepIdx >= funSteps.length;
    funBar.style.width = Math.round((stepIdx / funSteps.length) * 100) + '%';
    funBack.hidden = stepIdx === 0;
    funDone.hidden = !done;
    funSteps.forEach((s, i) => s.classList.toggle('is-on', !done && i === stepIdx));
    if (!done) return;

    const prog = progs[cur];
    funSum.textContent = '';
    funSum.appendChild(el('div', 'bw-funnel__sum-t', 'Подберём под ваш запрос'));
    const chips = el('div', 'bw-funnel__chips');
    funSteps.forEach(s => {
      const a = answers[s.getAttribute('data-step')];
      if (a) chips.appendChild(el('span', '', a));
    });
    chips.appendChild(el('span', '', prog.name));
    if (prog.rate != null) chips.appendChild(el('span', '', 'платёж ' + odo.textContent.trim() + ' ₽/мес'));
    funSum.appendChild(chips);
  }

  funSteps.forEach((stepEl, i) => {
    stepEl.querySelectorAll('.bw-opt').forEach(btn => btn.addEventListener('click', () => {
      answers[stepEl.getAttribute('data-step')] = btn.textContent.trim();
      stepIdx = i + 1;
      drawFunnel();
    }));
  });
  funBack.addEventListener('click', () => {
    if (stepIdx > 0) { stepIdx -= 1; drawFunnel(); }
  });

  drawFunnel();
  calc();
})();
